import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { NavbarComponent } from './navbar/navbar.component';
import { childTokenGuard } from './Guards/child-token.guard';
import { RefreshComponent } from './refresh/refresh.component';
import { ResetPasswordNewComponent } from './reset-password-new/reset-password-new.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { FilePreviewComponent } from './shared/file-preview/file-preview.component';
import { RecoverComponent } from './recover/recover.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { VesselsComponent } from './vessels/vessels.component';

const routes: Routes = [
	{ path: '', redirectTo: '/login', pathMatch: 'full' },
	{ path: 'refresh', component: RefreshComponent },
	{ path: 'login', component: LoginComponent },
	{ path: 'recover', component: RecoverComponent },
	{ path: 'setnewpassword/:user/:token', component: ResetPasswordComponent },
	{ path: 'forgot-password', component: ResetPasswordNewComponent },
	{
		path: 'app', component: NavbarComponent, data: { breadcrumb: 'TopNavBar' }, canActivate: [childTokenGuard], children: [
			{ path: 'vessels', component: VesselsComponent, data: { animation: 1 } },
			{ path: 'dashboard/:vesselId', component: DashboardComponent, data: { animation: 2 } },
			{ path: 'file-preview', component: FilePreviewComponent, data: { animation: 100 } },
		]
	},
	{ path: '**', redirectTo: '/login', pathMatch: 'full' },
];

@NgModule({
	imports: [RouterModule.forRoot(routes)],
	exports: [RouterModule]
})
export class AppRoutingModule { }
